import { managerIsNoGroupMember, useUserCollectionsState } from '@tuqqi/web'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

const _GroupViewListenerView = (props) => {
    const {userCollectionsState} = useUserCollectionsState()
    const {pathname, userRole, urlQuery} = props


    useEffect(() => {
        const url = urlQuery
        if(!url) {
            managerIsNoGroupMember.clear()
            return
        }

        const collectionUid = url.slice(1);
        if(!collectionUid) {
            managerIsNoGroupMember.clear()
            return
        }
        managerIsNoGroupMember.setIsNoGroupMember(collectionUid, userRole, userCollectionsState.data)
    }, [pathname, userRole, userCollectionsState.data])

    return null
}

const mapStateToProps = (state, ownProps) => ({
    userRole: state.data.userData.userDetails.data?.role ?? ''
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch,
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(_GroupViewListenerView)